<template>
  <Grid v-bind="{ ...props }" />
</template>

<script>
// Constants
import Constants from '../../constants/constants';

// Components
import Grid from '../shared/Grid.vue';

export default {
  name: 'CoolantSampleGrid',
  data() {
    return {
      props: {
        api: { ...Constants.Api.Endpoint.CoolantSample },
        columns: Constants.Grid.CoolantSample.columns,
        doClientSide: Constants.Grid.CoolantSample.doClientSide,
        filter: Constants.Grid.CoolantSample.filter,
        paging: Constants.Grid.CoolantSample.paging,
        searchHeader: Constants.Grid.CoolantSample.searchHeader,
        searchPlaceholder: Constants.Grid.CoolantSample.searchPlaceholder,
        sort: Constants.Grid.CoolantSample.sort,
        title: Constants.Grid.CoolantSample.title
      }
    };
  },
  components: {
    Grid
  }
};
</script>
